module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_osc.220d438e.svg";